import {useTranslation} from 'react-i18next';
import {AiOutlineLoading} from 'react-icons/ai';

export default function Loading() {
  const {t} = useTranslation();
  return (
    <div className="container h-screen">
      <div className="flex h-full flex-col items-center justify-center gap-8">
        <AiOutlineLoading size={50} style={{color: '#8c33e6'}} className="animate-spin" />
        <span>{t('Loading')}...</span>
      </div>
    </div>
  );
}
